import { render } from "./DiscographyView.vue?vue&type=template&id=890d0bba&scoped=true"
import script from "./DiscographyView.vue?vue&type=script&lang=js"
export * from "./DiscographyView.vue?vue&type=script&lang=js"

import "./DiscographyView.vue?vue&type=style&index=0&id=890d0bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-890d0bba"]])

export default __exports__